import React from 'react';

import Head from 'next/head';
import { Loader } from '@www/components/Loader';

import { Redirect } from '@www/components/Redirect';

import { IMBButtonHoverVariant, MBButton, MBText, THEME } from '@meetbutter/ui';
import { Box } from '@material-ui/core';
import { ButterLogoLong } from '@meetbutter/ui/build/components/Icons';
import { LinkTracker } from '@www/components/LinkTracker';

export const RedirectScreen = ({ url }) => {
  return (
    <>
      <Head>
        <meta name="robots" content="noindex nofollow" />
      </Head>

      <Redirect url={url} delay={2500} />
      <Box
        bgcolor={THEME.colors.primary.IceterineYellow100}
        width="100vw"
        height="100vh"
        position="relative"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Box position="absolute" top={17} left={21}>
          <ButterLogoLong boxProps={{ width: 110 }} />
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flexDirection="column"
          height="100%"
          width="100%"
          maxHeight="640px"
          p={4}
          boxSizing="border-box"
        >
          <Box />
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
          >
            <Box width={50} height={50}>
              <Loader bgcolor="transparent" />
            </Box>
            <MBText
              mt={4}
              fontWeight="bold"
              fontSize={64}
              t="common:status.redirecting-you"
            />
            <MBText mb={1} t="loading:redirecting.message" html />
          </Box>

          <Box>
            <LinkTracker href={url}>
              <MBButton
                padding="14px 20px"
                hoverVariant={IMBButtonHoverVariant.darken}
                color="#fff"
                background="#000"
              >
                <MBText t="common:buttons.redirect-now" />
              </MBButton>
            </LinkTracker>
          </Box>
        </Box>
      </Box>
    </>
  );
};
